// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { IAllocationRequest } from '../pages/registry/allocationRequest/types';
import { getInstIdentifierKey } from './getInstConfigKey';

export const getAllocationRequestsWithConfig = (
  configMap: Set<string>,
  allocationRequestRows?: IAllocationRequest[],
) => {
  if (!allocationRequestRows) {
    return [];
  }
  return allocationRequestRows.filter((r) => {
    const { id, admin } = r.payload.transferLeg.instrumentId;
    const key = getInstIdentifierKey(id, admin);
    const hasConfig = configMap.has(key);
    return hasConfig;
  });
};
